import { ApiError } from "@wellcheck/api-client";

// 同じ endpoint が別の理由 (対象外になった人の拒否) でも 409 を返すため、status ではなく detail で判別する。
const CONTACT_EDIT_CLOSED_DETAIL = "contact edit period is closed";

export function isContactEditClosedError(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 409) {
    return false;
  }
  const data = error.data;
  if (typeof data !== "object" || data === null || !("detail" in data)) {
    return false;
  }
  return (data as { detail: unknown }).detail === CONTACT_EDIT_CLOSED_DETAIL;
}
